/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITiposClientes from 'Infotrack@Modelos/smartStock/tiposClientes/entidades/tiposClientes';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<ITiposClientes>> => [
    {
        title: formatMessage({ id: 'tiposClientes.tipoClienteDescripcion' }),
        field: 'TipoClienteDescripcion',
    },
    {
        title: formatMessage({ id: 'productos.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, tiposClientes?: ITiposClientes) => void,
    cargarTiposClientes: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (tiposClientes: ITiposClientes) => void
): Array<Action<ITiposClientes>> => [
    {
        icon: 'refresh',
        onClick: cargarTiposClientes,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: 'add',
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as ITiposClientes),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarTiposClientes,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as ITiposClientes),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];
